import Radio, { RadioProps } from '@material-ui/core/Radio'

import React from 'react'
import clsx from 'clsx'
import { useStyles } from './styles'

interface CustomRadioProps extends RadioProps {
    className?: string
}

export const CustomRadio: React.FC<CustomRadioProps> = ({ className = '', ...rest }) => {
    const classes = useStyles()

    return (
        <Radio
            className={clsx(classes.root, className)}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...rest}
        />
    )
}

export default React.memo(CustomRadio)
